/**
 * Legacy loader — logic lives in aaramya-upsell.js (loaded via aaramya-storefront-boot).
 */
(function () {
  if (window.__aaUpsellLoaded) return;
  const s = document.createElement('script');
  s.src = (document.querySelector('script[src*="aaramya-upsell"]') || {}).src;
  if (!s.src) return;
  document.head.appendChild(s);
})();

(function () {
  if (window.__aaCardTaglinesLoaded) return;
  window.__aaCardTaglinesLoaded = true;

  const taglines = {
    'nature-s-secret-homemade-herbal-hair-shampoo': 'Honest formulation — no conditioner needed.',
    'magical-hair-oil': 'Weekly herbal oiling for nourished, manageable hair.',
    'hair-toner-100ml': 'Daily herbal scalp spray — no heavy oiling.',
    'aaramya-herbal-facewash': 'Gentle neem + aloe cleanse for everyday skin care.',
    'lemon-dishwash': 'Natural lemon power for everyday utensils.',
    'complete-hair-ritual-kit': 'Toner + oil + shampoo for a complete hair ritual.',
    'hair-care-duo-oil-shampoo': 'Oil + shampoo for weekly wash-day care.',
    'daily-hair-refresh-kit': 'Toner + oil for lightweight scalp nourishment.',
    'aaramya-essentials-kit': 'Facewash + complete hair care in one starter kit.',
    'aaramya-face-serum-60gm': 'Lightweight overnight hydration with aloe and rose.'
  };

  function handleFromHref(href) {
    const match = (href || '').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function applyTaglines(root) {
    (root || document).querySelectorAll('.product-grid__item').forEach(function (item) {
      if (item.querySelector('.aa-card-tagline')) return;

      const link = item.querySelector('a.product-card__link[href*="/products/"]');
      const tagline = taglines[handleFromHref(link && link.getAttribute('href'))];
      const titleLink = item.querySelector('a[ref="productTitleLink"]');
      if (!tagline || !titleLink) return;

      const line = document.createElement('p');
      line.className = 'aa-card-tagline';
      line.textContent = tagline;
      titleLink.insertAdjacentElement('afterend', line);
    });
  }

  function bootTaglines() {
    applyTaglines(document);
    const grid = document.querySelector('.product-grid');
    if (!grid || grid.dataset.aaTaglineObserver === 'true') return;

    grid.dataset.aaTaglineObserver = 'true';
    new MutationObserver(function () {
      applyTaglines(grid);
    }).observe(grid, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootTaglines, { once: true });
  } else {
    bootTaglines();
  }
})();
